import React, { useState, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCommentAlt, faStickyNote } from '@fortawesome/free-regular-svg-icons'

import { DnD_element_type_menu, DnD_element_type_category } from '../../common/ConstantValues'
import DragableComponentInList from './DragableComponentInList'
import './ElementPicker.css'
import './CommonPickerStyle.css'

// DnD
import { useDrag } from 'react-dnd'
import DraggableComponent from '../../MessageManage/DraggableComponent';
import DnDContext from '../../DnDContext';

const ElementPicker = (props) => {
  const [isDragging, setIsDragging] = useState(false)
  const elementMessageRef = useRef()
  const elementSliderPageRef = useRef()
  // if (elementMessageRef.current) {
  //   console.log('elementMessageRef.current.offsetHeight :', elementMessageRef.current.offsetHeight);
  // }
  const ElementStyle = {
    transition: '0.15s',
    backgroundColor: isDragging ? '#1085c5' : 'transparent',
    color: isDragging ? 'white' : 'black',
  }

  const dragStart = (e) => {
    setIsDragging(true)
  }

  const dragEnd = (e) => {
    setIsDragging(false)
  }

  return (
    <div className="picker-style element-picker">
      <div className="row-group">
      <DragableComponentInListWrap 
        title="메시지"
        onDragStart={dragStart} 
        onDragEnd={dragEnd} 
        type={DnD_element_type_menu.ELEMENT.MESSAGE} 
        icon={(<FontAwesomeIcon icon={faCommentAlt} size={"lg"} />)} 
        cat_type={DnD_element_type_category.MENU} 
      />
        {/* <DraggableComponent 
          key={0}
          onDragStart={dragStart} 
          onDragEnd={dragEnd} 
          type={DnD_element_type_menu.ELEMENT.MESSAGE}
          cat_type={DnD_element_type_category.MENU}>
          <div id="message" className="element" ref={elementMessageRef}>
            <FontAwesomeIcon icon={faCommentAlt} size={"lg"} />
            <p> 메시지 </p>
          </div>
        </DraggableComponent> */}
        <DragableComponentInListWrap 
          title="슬라이드 페이지"
          onDragStart={dragStart} 
          onDragEnd={dragEnd}
          prefix_type={"NORMAL"}
          type={DnD_element_type_menu.ELEMENT.SLIDE_PAGE} 
          icon={(<FontAwesomeIcon icon={faStickyNote} size={"lg"} />)} 
          cat_type={DnD_element_type_category.MENU} 
        />
        {/* <DraggableComponent
          key={1}
          onDragStart={dragStart} 
          onDragEnd={dragEnd}
          prefix_type={"NORMAL"} // 특수하게 element지만 prefix_type이 있는 경우
          type={DnD_element_type_menu.ELEMENT.SLIDE_PAGE}
          contentHeight={62.5}
          cat_type={DnD_element_type_category.MENU}>
          <div id="slide_page" className="element" ref={elementSliderPageRef}>
            <FontAwesomeIcon icon={faStickyNote} />
            <p> 페이지 </p>
          </div>
        </DraggableComponent> */}
      </div>
    </div>
  )
}

const DragableComponentInListWrap = (props) => {
  return (
    <DnDContext>
      <DragableComponentInList {...props}/>
    </DnDContext>
  )
}

export default ElementPicker